@if (showSkip) {
  <div class="question-skip">
    <label class="custom-toggle custom-toggle--md custom-toggle--inline custom-toggle--transparent">
      <input
        type="checkbox"
        [checked]="skipped"
        [(ngModel)]="skipped"
        (ngModelChange)="onSkipChange()"
        name="add-note-toggle"
        id="skip-driver-details-toggle">
        <span class="custom-toggle__indi"></span>
        <span class="custom-toggle__label">Skip for now</span>
      </label>
    </div>
  }

  @if (showHeader) {
    <div class="question-panel__header">
      <div class="question-panel__title">{{premium?.description ? premium?.description : headerTitle}}</div>
      <div class="question-panel__cost">
        <p>
          <!--<strong *ngIf="premium?.premium === null || premium?.premium < 0" class="item-price">calculating...</strong>-->
          @if (premium?.premium >= 0) {
            <strong class="item-price">
              {{premium?.premium ? questionService?.accounting?.formatMoney(premium?.premium)
            : questionService?.accounting?.formatMoney(headerPrice)}}</strong>
            } /{{questionService?.currency?.display_freq}}
          </p>
        </div>
      </div>
    }
    <div class="form-group form-group--sm">
      <label>{{question?.question_prompt || question?.question_copy || question?.email_version}}</label>
      <app-slider
        [question]="question"
        [sliderStep]="10"
        [sliderMin]="sliderMin"
        [sliderMax]="sliderMax"
        [sliderInit]="sliderInit"
        (slideUpdate)=saveSliderValue($event)>
      </app-slider>
    </div>
    @if (showCalculatedText) {
      <p class="mt-20 mb-15">
        <a href="#question-modal" class="button-control button-control--opacity-hover" data-toggle="modal">
          <svg class="icon">
            <use xlink:href="#info-icon"></use>
          </svg>
          <span>How is this value calculated?</span>
        </a>
      </p>
    }
